import { Navigate, useParams } from 'react-router-dom'

export const LegacyUrlRedirect = () => {
  const { id, floorId, versionId } = useParams<{ id: string; floorId: string; versionId: string }>()
  return <Navigate replace to={`/facility/${id}/area/${floorId}/version/${versionId}`} />
}
